import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";

interface DatePickerProps {
  value: string | string[] | null;
  label?: string;
  errorMessages?: string[];
  range?: boolean;
  type?: "date" | "month";
  min?: string;
  max?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    value: null,
    label: null,
    errorMessages: null,
    range: { type: Boolean },
    type: null,
    min: null,
    max: null
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: string | string[] | null;
  label?: string;
  errorMessages?: string[];
  range?: boolean;
  type?: "date" | "month";
  min?: string;
  max?: string;
};



const dateValue = ref(props.value);
const dateDisplayText = computed(() => {
  if (!props.value) {
    return "";
  }

  return Array.isArray(props.value)
    ? props.value.map((c: string) => formatDate(c.split("T")[0])).join(" - ")
    : formatDate((props.value as string).split("T")[0]);
});

watch(dateValue, (newValue) => {
  emit("input", newValue);
});

function formatDate(dateText: string) {
  if (!dateText) {
    return "";
  }
  const date = new Date(dateText);
  const day = `${date.getDate()}`.padStart(2, "0");
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

return { __sfc: true,props, emit, dateValue, dateDisplayText, formatDate }
}

})